import Construction from "../pages/Construction";
import Error404 from "@/modules/frontend/pages/Error404";
import Maintenance from "../pages/Maintenance";

const otherRoutes = {
    PAGE_NOT_FOUND: {
        path: "*",
        element: <Error404 />
    },
    PAGE_404_NOT_FOUND: {
        path: "/page-not-found",
        element: <Error404 />
    },
    MAINTANANCE_PAGE: {
        path: "/manitanance",
        element: <Maintenance />
    },
    CONSTRUCTION_PAGE: {
        path: "/construction",
        element: <Construction />
    }
}

export default otherRoutes;